import { Component, inject } from '@angular/core';
import { Toast } from '@app/core/models/common.models';
import { DisplayToast } from '@app/core/store/states/ui/ui-state.actions';
import { pollUntilClose } from '@app/core/utilities/dom.utilities';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LoginFormComponent } from '../login-form/login-form.component';

@Component({
  selector: 'adspt-re-login-modal',
  templateUrl: './re-login-modal.component.html',
  styleUrls: ['./re-login-modal.component.scss'],
  imports: [TranslatePipe, LoginFormComponent],
})
export class ReLoginModalComponent {
  private translate = inject(TranslateService);
  private modal = inject(NzModalRef);

  @Dispatch() setToast = (t: Partial<Toast>) => new DisplayToast(t);

  closeModal(d: boolean) {
    this.modal.close(d);
  }

  success() {
    this.closeModal(true);
    this.setToast({ title: this.translate.instant('common.re-login.re-try'), type: 'success' });
  }
  error() {
    this.closeModal(false);
    this.setToast({ title: this.translate.instant('portal.creds-error'), type: 'error' });
  }
  onLoginAuth0(): void {
    const url = new URL(`${location.origin}/auth/login`);
    url.searchParams.append('redirect', `/monitor?close=true`);

    const popup = window.open(
      url,
      '_blank',
      `popup,width=500,height=540,left=${window.innerWidth / 2 - 250},top=${window.innerHeight / 2 - 270}`,
    );

    pollUntilClose(popup).then(() => this.closeModal(true));
  }
}
